// SettingsLoginPane.jsx

import React from 'react';

// Components
import SettingsModalPaneHeader from './SettingsModalPaneHeader';
import SettingsModalPaneContents from './SettingsModalPaneContents';
import LoginEdit from 'settings/wizard/login/LoginEdit';

/**
 * SettingsLoginPane
 *
 * Renders login management controls for the active base.
 *
 * @returns {ReactNode} The rendered login settings pane.
 */
const SettingsLoginPane = React.memo(() => {

  // ----- RENDER ----- //

  return (
        <>
            <SettingsModalPaneHeader
              title="Login"
              subtitle="Manage login settings"
            />

            <SettingsModalPaneContents>
                <div className="settings-modal-embedded-panel">
                    <LoginEdit />
                </div>
            </SettingsModalPaneContents>
        </>
    );
});

// Dev Tools
SettingsLoginPane.displayName = 'SettingsLoginPane';

export default SettingsLoginPane;
